import React from 'react';
import PropTypes from 'prop-types';
import { head } from 'lodash';
import { compose } from 'redux';
import { SectionHeading } from 'web-ui-components/lib/typography/headings';
import withContent from '../../../containers/withContent';
import paymentDetailsContent, { contentPropTypes } from './ChapsPaymentDetails.content';
import { verificationPropTypes } from '../../../states/payments/propTypes';
import { getChapsPaymentDetails } from '../../../utils/paymentsUtils';
import PaymentInfoTable from '../PaymentInfoTable';
import { fxChargesProptypes } from '../../../states/rates/propTypes';
import withFxCharge from '../../../containers/withFxCharge';

const ChapsPaymentDetails = ({
	content,
	payment: { payments, ...verificationInfo },
	fxCharges,
	newPaymentDates: { newSubmissionDate } = {},
}) => {
	const { title } = content;
	const firstPayment = head(payments);
	const chapsPayment = {
		...firstPayment,
		start_date: newSubmissionDate || firstPayment.start_date,
	};
	const paymentDetails = getChapsPaymentDetails(content, verificationInfo, chapsPayment, fxCharges[firstPayment.id]);
	return (
		<div>
			<SectionHeading>{title}</SectionHeading>
			<div className="u-margin-bottom-2">
				<PaymentInfoTable paymentDetails={paymentDetails} />
			</div>
		</div>
	);
};

ChapsPaymentDetails.propTypes = {
	content: PropTypes.shape(contentPropTypes).isRequired,
	payment: PropTypes.shape(verificationPropTypes).isRequired,
	fxCharges: PropTypes.shape(fxChargesProptypes),
	newPaymentDates: PropTypes.shape({
		newSubmissionDate: PropTypes.string,
	}),
};

export default compose(withContent({ content: paymentDetailsContent }), withFxCharge)(ChapsPaymentDetails);
